<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit Branch' : 'Add New Branch' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field"><span class="field-label">Branch id</span><input type="number" class="text-box-active" formControlName="establishmentId" /></div>
      <div class="field"><span class="field-label">Code</span><input class="text-box-active" formControlName="code" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Name</span><input class="text-box-active" formControlName="name" /></div>
      <div class="field"><span class="field-label">Landmark</span><input class="text-box-active" formControlName="landmark" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Address</span><input class="text-box-active" formControlName="address" /></div>
      <div class="field"><span class="field-label">Location URL</span><input class="text-box-active" formControlName="locationUrl" /></div>
    </div>
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="sa-establishment-state">State</label>
        <input
          id="sa-establishment-state"
          type="text"
          class="text-box-active readonly-field"
          formControlName="state"
          readonly
        />
      </div>
      <div class="field">
        <label class="field-label" id="sa-establishment-district-label">District</label>
        @if(districtList.length > 1){
        <mat-form-field
          class="ac-select-field"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-select
            id="sa-establishment-district"
            aria-labelledby="sa-establishment-district-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="district"
            placeholder="Select district"
            (selectionChange)="onDistrictChange()"
          >
            @for(district of districtList; track district){
            <mat-option [value]="district">{{ district }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @else {
        <input
          aria-labelledby="sa-establishment-district-label"
          type="text"
          class="text-box-active readonly-field"
          formControlName="district"
          readonly
        />
        }
      </div>
    </div>
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="sa-establishment-pincode">Pincode</label>
        <div class="input-status-wrapper">
          <input
            id="sa-establishment-pincode"
            type="text"
            class="text-box-active"
            formControlName="pincode"
            inputmode="numeric"
            autocomplete="postal-code"
            maxlength="6"
            aria-describedby="sa-establishment-pincode-message"
          />
          @if(isPincodeLoading){
          <span class="lookup-spinner" aria-label="Checking pincode"></span>
          }
        </div>
        @if(pincodeControl?.touched && pincodeControl?.hasError('pattern')){
        <span id="sa-establishment-pincode-message" class="field-message field-error">
          Enter a valid 6-digit pincode.
        </span>
        } @else if(pincodeLookupMessage){
        <span
          id="sa-establishment-pincode-message"
          class="field-message"
          [class.field-error]="pincodeLookupStatus === 'error'"
          [class.field-success]="pincodeLookupStatus === 'valid'"
        >
          {{ pincodeLookupMessage }}
        </span>
        }
      </div>
      <div class="field">
        <span class="field-label">Status</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="status">
            <mat-option [value]="1">Active</mat-option>
            <mat-option [value]="0">Inactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button
      type="button"
      class="ac-primary-btn"
      [disabled]="isLoading || isPincodeLoading"
      (click)="submit()"
    >
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
